import { render, staticRenderFns } from "./AuthPasswordRestoreForm.vue?vue&type=template&id=3ed83f50&scoped=true&"
import script from "./AuthPasswordRestoreForm.vue?vue&type=script&lang=js&"
export * from "./AuthPasswordRestoreForm.vue?vue&type=script&lang=js&"
import style0 from "./AuthPasswordRestoreForm.vue?vue&type=style&index=0&id=3ed83f50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed83f50",
  null
  
)

export default component.exports